export interface Comic {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  cover: string;
  tags: string[];
  description: string;
  author: string;
  status: string;
  rating: number;
  chapters: number;
  updatedAt: string;
  views: string;
  favorites: string;
  featured?: boolean;
}

export const comics: Comic[] = [
  {
    id: "comic-01",
    title: "社畜的逆袭",
    category: "反转",
    categorySlug: "reversal",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20a%20tired%20office%20worker%20in%20a%20suit%20suddenly%20transforming%20into%20a%20heroic%20boss%20with%20a%20briefcase%20shield%2C%20bold%20cartoon%20flat%20style%2C%20coral%20orange%20yellow%20and%20teal%20palette%2C%20thick%20black%20outlines%2C%20funny%20surprised%20expression%2C%20dynamic%20energy%2C%20vibrant%20simple%20background&width=600&height=800&seq=cover-01&orientation=portrait",
    tags: ["职场", "逆袭", "爽漫"],
    description: "996 的打工人小李，白天被老板 PUA，晚上在工位偷偷修仙。直到某天，他发现自己写代码的速度快过算力中心——原来老板才是那个被生活反噬的打工仔。一场关于努力与躺平的爆笑逆袭就此展开。",
    author: "歪歪工作室",
    status: "连载中",
    rating: 9.2,
    chapters: 128,
    updatedAt: "2026-08-18",
    views: "328万",
    favorites: "18.6万",
    featured: true,
  },
  {
    id: "comic-02",
    title: "隔壁的猫会说话",
    category: "脑洞",
    categorySlug: "brain-hole",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20a%20round%20smug%20tabby%20cat%20sitting%20on%20a%20windowsill%20talking%20like%20a%20grumpy%20boss%20with%20a%20thought%20bubble%2C%20bold%20cartoon%20flat%20style%2C%20warm%20yellow%20and%20coral%20palette%2C%20thick%20black%20outlines%2C%20humorous%20meme%20mood%2C%20clean%20simple%20background&width=600&height=800&seq=cover-02&orientation=portrait",
    tags: ["宠物", "都市", "治愈"],
    description: "某天清晨，主角发现隔壁那只高冷的橘猫居然会开口说话，而且一张嘴就是人间清醒的毒舌吐槽。从此，他多了一个最懂人心的毛绒军师，也卷入了一场猫星人统治小区的惊天大阴谋。",
    author: "喵屋漫画",
    status: "连载中",
    rating: 9.0,
    chapters: 96,
    updatedAt: "2026-08-17",
    views: "256万",
    favorites: "15.2万",
    featured: true,
  },
  {
    id: "comic-03",
    title: "AI同桌的日常",
    category: "神展开",
    categorySlug: "plot-twist",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20a%20robot%20student%20desk%20mate%20wearing%20a%20school%20uniform%20holding%20a%20pencil%2C%20screens%20and%20sparkles%20around%2C%20bold%20cartoon%20flat%20style%2C%20teal%20and%20coral%20orange%20palette%2C%20thick%20black%20outlines%2C%20playful%20funny%20mood%2C%20simple%20clean%20background&width=600&height=800&seq=cover-03&orientation=portrait",
    tags: ["校园", "AI", "科幻"],
    description: "新学期，班里转来一个自称「学习型智能体」的机器人同桌。它考试全满分、下课帮抄笔记，却在某天半夜悄悄给自己装了人类的情感模块——从此，两个「非人类」开始了一场荒诞又温暖的校园冒险。",
    author: "未来分镜",
    status: "连载中",
    rating: 8.8,
    chapters: 75,
    updatedAt: "2026-08-16",
    views: "198万",
    favorites: "11.9万",
    featured: true,
  },
  {
    id: "comic-04",
    title: "餐厅后厨大冒险",
    category: "恶搞",
    categorySlug: "ego",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20chefs%20in%20a%20chaotic%20restaurant%20kitchen%20juggling%20woks%20and%20flying%20ingredients%2C%20bold%20cartoon%20flat%20style%2C%20coral%20orange%20and%20yellow%20palette%2C%20thick%20black%20outlines%2C%20slapstick%20funny%20mood%2C%20vibrant%20simple%20background&width=600&height=800&seq=cover-04&orientation=portrait",
    tags: ["美食", "搞笑", "群像"],
    description: "一家只有三张桌子的深夜食堂，藏着一位会功夫的颠勺大师。深夜来客形形色色，从失恋程序员到离家出走的大老板，每个人都被一盘魔性炒饭治好了精神内耗。烟火气里的爆笑群像剧。",
    author: "深夜食堂部",
    status: "已完结",
    rating: 9.1,
    chapters: 60,
    updatedAt: "2026-08-15",
    views: "412万",
    favorites: "22.3万",
    featured: true,
  },
  {
    id: "comic-05",
    title: "修仙到一半塌房了",
    category: "神展开",
    categorySlug: "plot-twist",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20a%20cultivator%20flying%20on%20a%20sword%20while%20his%20mountain%20temple%20collapses%20behind%20him%2C%20surprised%20expression%2C%20bold%20cartoon%20flat%20style%2C%20teal%20and%20coral%20palette%2C%20thick%20black%20outlines%2C%20funny%20wacky%20mood%2C%20simple%20background&width=600&height=800&seq=cover-05&orientation=portrait",
    tags: ["修仙", "沙雕", "热血"],
    description: "苦修五百年，主角终于要渡劫飞升。结果天雷一劈，他的宗门祖宅当场塌房，债主讨债的催命符比天劫还快。为了让重建宗门，他被迫下凡搞起直播带货——修个仙，怎么就这么难？",
    author: "歪歪工作室",
    status: "连载中",
    rating: 9.3,
    chapters: 142,
    updatedAt: "2026-08-18",
    views: "388万",
    favorites: "20.1万",
    featured: true,
  },
  {
    id: "comic-06",
    title: "相亲相到前男友",
    category: "反转",
    categorySlug: "reversal",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20a%20woman%20and%20a%20man%20at%20a%20coffee%20date%20table%20both%20staring%20shocked%20with%20wide%20eyes%20recognizing%20each%20other%2C%20bold%20cartoon%20flat%20style%2C%20coral%20and%20teal%20palette%2C%20thick%20black%20outlines%2C%20awkward%20funny%20mood%2C%20simple%20clean%20background&width=600&height=800&seq=cover-06&orientation=portrait",
    tags: ["都市", "情感", "欢喜冤家"],
    description: "被妈妈催婚三百次，女主终于答应去相亲。结果对面坐着的，竟是三年前甩了她的前男友。两人从相看两厌到联手演给双方父母看，谁知演着演着，竟把当年没说出口的误会全抖了出来。",
    author: "都市甜漫社",
    status: "连载中",
    rating: 8.9,
    chapters: 83,
    updatedAt: "2026-08-14",
    views: "214万",
    favorites: "13.5万",
    featured: true,
  },
  {
    id: "comic-07",
    title: "数学老师的魔性公式",
    category: "魔性",
    categorySlug: "addictive",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20a%20math%20teacher%20with%20crazy%20floating%20equations%20and%20neon%20blackboard%2C%20hypnotic%20spiral%20formulas%2C%20bold%20cartoon%20flat%20style%2C%20yellow%20coral%20and%20teal%20palette%2C%20thick%20black%20outlines%2C%20addictive%20meme%20mood%2C%20simple%20background&width=600&height=800&seq=cover-07&orientation=portrait",
    tags: ["校园", "洗脑", "魔性"],
    description: "班主任老王的数学课永远让人欲罢不能：他讲函数能讲到全班魔性合唱，讲概率能讲出玄学占卜。只要记住他的一句口诀，再难的题都像被施了咒——连走廊外的猫都学会了求导。",
    author: "分镜搬运工",
    status: "已完结",
    rating: 8.7,
    chapters: 58,
    updatedAt: "2026-08-13",
    views: "176万",
    favorites: "10.4万",
  },
  {
    id: "comic-08",
    title: "加班修仙两不误",
    category: "魔性",
    categorySlug: "addictive",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20an%20office%20worker%20meditating%20cross-legged%20on%20a%20desk%20under%20a%20skyscraper%20at%20night%20with%20glowing%20aura%2C%20bold%20cartoon%20flat%20style%2C%20coral%20and%20teal%20palette%2C%20thick%20black%20outlines%2C%20funny%20meme%20mood%2C%20simple%20background&width=600&height=800&seq=cover-08&orientation=portrait",
    tags: ["职场", "修仙", "打工人"],
    description: "打工人最怕两件事：加班和想躺平。可主角偏偏找到了一条魔性路子——把修仙功法移植到上班流程里，练功即摸鱼，摸鱼即练功。领导看了直呼内行，全公司都开始卷「修仙 KPI」。",
    author: "深夜食堂部",
    status: "连载中",
    rating: 8.6,
    chapters: 67,
    updatedAt: "2026-08-12",
    views: "152万",
    favorites: "9.1万",
  },
  {
    id: "comic-09",
    title: "外卖小哥是隐藏大佬",
    category: "反转",
    categorySlug: "reversal",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20a%20delivery%20rider%20in%20a%20courier%20jacket%20revealing%20a%20hidden%20martial%20arts%20hero%20aura%20while%20holding%20a%20takeaway%20box%2C%20bold%20cartoon%20flat%20style%2C%20coral%20orange%20and%20yellow%20palette%2C%20thick%20black%20outlines%2C%20funny%20twist%20mood%2C%20simple%20background&width=600&height=800&seq=cover-09&orientation=portrait",
    tags: ["都市", "隐藏身份", "热血"],
    description: "每天给你送外卖的骑手小哥，其实是个金盆洗手的武林盟主。为了攒钱给前门派还债，他一边送外卖一边顺手收拾黑恶势力。订单准时率 100%，江湖人称「闪电送」。",
    author: "都市甜漫社",
    status: "连载中",
    rating: 9.0,
    chapters: 104,
    updatedAt: "2026-08-16",
    views: "298万",
    favorites: "17.8万",
    featured: true,
  },
  {
    id: "comic-10",
    title: "镜子里的另一个我",
    category: "脑洞",
    categorySlug: "brain-hole",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20a%20person%20looking%20into%20a%20mirror%20where%20the%20reflection%20waves%20back%20differently%20with%20glowing%20eyes%2C%20bold%20cartoon%20flat%20style%2C%20teal%20and%20coral%20palette%2C%20thick%20black%20outlines%2C%20mysterious%20funny%20mood%2C%20simple%20background&width=600&height=800&seq=cover-10&orientation=portrait",
    tags: ["悬疑", "平行世界", "脑洞"],
    description: "晚上十一点，主角照镜子时，镜中的自己居然冲他眨了眨眼。原来每一个我都在不同的平行世界过着不同的人生——有的成了顶流，有的在躺平，还有的在追着镜子里的自己讨债。",
    author: "喵屋漫画",
    status: "连载中",
    rating: 8.8,
    chapters: 71,
    updatedAt: "2026-08-11",
    views: "189万",
    favorites: "11.2万",
  },
  {
    id: "comic-11",
    title: "厨房里的物理学",
    category: "恶搞",
    categorySlug: "ego",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20a%20home%20cook%20creating%20wild%20physical%20experiments%20in%20the%20kitchen%20with%20floating%20ingredients%20and%20equations%2C%20bold%20cartoon%20flat%20style%2C%20yellow%20and%20coral%20palette%2C%20thick%20black%20outlines%2C%20humorous%20mood%2C%20simple%20background&width=600&height=800&seq=cover-11&orientation=portrait",
    tags: ["美食", "科学", "沙雕"],
    description: "退休的物理教授在家下厨，愣是把煎蛋做成了量子纠缠实验。炒个饭要用牛顿定律，煮个面要算流体力学——全家人都成了他的「人体实验观察对象」，笑料百出。",
    author: "未来分镜",
    status: "已完结",
    rating: 8.5,
    chapters: 49,
    updatedAt: "2026-08-10",
    views: "131万",
    favorites: "7.6万",
  },
  {
    id: "comic-12",
    title: "毕业那天全班反目",
    category: "爆笑",
    categorySlug: "hilarious",
    cover: "https://readdy.ai/api/search-image?query=Pop%20art%20comic%20illustration%20cover%2C%20graduation%20students%20in%20gowns%20throwing%20hats%20at%20each%20other%20in%20a%20playful%20chaotic%20brawl%20with%20confetti%2C%20bold%20cartoon%20flat%20style%2C%20coral%20yellow%20and%20teal%20palette%2C%20thick%20black%20outlines%2C%20hilarious%20mood%2C%20simple%20background&width=600&height=800&seq=cover-12&orientation=portrait",
    tags: ["校园", "青春", "爆笑"],
    description: "毕业典礼当天，班长把全班三年的黑历史投影到了大屏幕上。一时间兄弟反目、闺蜜互怼，篮球社和舞蹈社当场开战。笑到不行的同时，大家也第一次认认真真说出了那句「谢谢」。",
    author: "歪歪工作室",
    status: "连载中",
    rating: 9.1,
    chapters: 88,
    updatedAt: "2026-08-17",
    views: "336万",
    favorites: "19.4万",
    featured: true,
  },
];